import { ProjectIssueType } from "@/libraries/bxp-web-stargate-client/src";

import {
    USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT,
    USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT,
    USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL,
    USER_SEGMENTATION_TEAM_TYPE_DESIGN,
    USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT,
    USER_SEGMENTATION_TEAM_TYPE_SOFTWARE,
    USER_SEGMENTATION_TEAM_TYPE_MARKETING,
    USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
    USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE,
    USER_SEGMENTATION_TEAM_TYPE_SALES,
    USER_SEGMENTATION_TEAM_TYPE_HR,
    USER_SEGMENTATION_TEAM_TYPE_LEGAL,
    USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE
} from "../../../models/user-segmentation";

import messages from "./messages";

import type { MessageDescriptor } from "react-intl";

export const USER_SEGMENTATION_TEAM_TYPE_UNKNOWN = "unknown";

export interface IssueType {
    name: MessageDescriptor;
    avatarId: number;
    id: string;
}

export interface Configuration {
    issueTypes: IssueType[];
    columns: MessageDescriptor[];
}

export type ProjectConfig = {
    issueTypes: ProjectIssueType[];
    columns: string[];
    projectName: string;
};

const featureIssueType: IssueType = {
    name: messages.featureIssueTypeName,
    avatarId: 10314,
    id: "1"
};
const taskIssueType: IssueType = {
    name: messages.taskIssueTypeName,
    avatarId: 10318,
    id: "14"
};
const storyIssueType: IssueType = {
    name: messages.storyIssueTypeName,
    avatarId: 10315,
    id: "3"
};
const assetIssueType: IssueType = {
    name: messages.assetIssueTypeName,
    avatarId: 10309,
    id: "5"
};

const incidentIssueType: IssueType = {
    name: messages.incidentIssueTypeName,
    avatarId: 10304,
    id: "9"
};
const serviceRequestIssueType: IssueType = {
    name: messages.serviceRequestIssueTypeName,
    avatarId: 10308,
    id: "10"
};
const campaignIssueType: IssueType = {
    name: messages.campaignIssueTypeName,
    avatarId: 10313,
    id: "12"
};
const softwareDevelopmentSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...taskIssueType }, { ...storyIssueType }],
    columns: [
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.inReviewColumnName,
        messages.doneColumnName
    ]
};
const projectManagementSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...featureIssueType }, { ...taskIssueType }],
    columns: [
        messages.ideaColumnName,
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.inReviewColumnName,
        messages.doneColumnName
    ]
};
const productManagementSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...featureIssueType }, { ...taskIssueType }],
    columns: [
        messages.ideaColumnName,
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.testingColumnName,
        messages.doneColumnName
    ]
};
const designSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...taskIssueType }, { ...assetIssueType }],
    columns: [
        messages.todoColumnName,
        messages.inDesignColumnName,
        messages.userTestingColumnName,
        messages.approvedColumnName,
        messages.liveColumnName
    ]
};
const itSupportSampleProjectConfiguration: Configuration = {
    issueTypes: [
        { ...taskIssueType },
        { ...incidentIssueType },
        { ...serviceRequestIssueType }
    ],
    columns: [
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.waitingForCustomerColumnName,
        messages.resolvedColumnName
    ]
};

const marketingSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...taskIssueType }, { ...campaignIssueType }],
    columns: [
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.doneColumnName
    ]
};

const otherPersonalSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...taskIssueType }],
    columns: [
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.doneColumnName
    ]
};

export const defaultSampleProjectConfiguration: Configuration = {
    issueTypes: [{ ...taskIssueType }],
    columns: [
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.inReviewColumnName,
        messages.doneColumnName
    ]
};

export const SampleProjectConfigurations: {
    [teamType: string]: Configuration;
} = {
    [USER_SEGMENTATION_TEAM_TYPE_SOFTWARE]:
        softwareDevelopmentSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT]:
        projectManagementSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT]:
        productManagementSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_DESIGN]: designSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT]:
        itSupportSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_MARKETING]:
        marketingSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL]:
        otherPersonalSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_OPERATIONS]: defaultSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE]:
        defaultSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_SALES]: defaultSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_HR]: defaultSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_LEGAL]: defaultSampleProjectConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE]:
        defaultSampleProjectConfiguration
};

export const KANBAN_PROJECT_DEFAULTS = {
    projectKey: "KAN",
    template: "KANBAN",
    defaultProjectName: messages.defaultKanbanProjectName
};

export const SCRUM_PROJECT_DEFAULTS = {
    projectKey: "SCRUM",
    template: "SCRUM",
    defaultProjectName: messages.defaultScrumProjectName
};
